export { default as NikoPatientSalesOrderViewStore } from './NikoPatientSalesOrderViewStore';